import {useRefetchOnAliveUpdate} from './use-refetch-on-alive-update'
import {useDescriptionData} from '../page-data/loaders/use-description-data'

export function useDescriptionLiveUpdates(channel: string): void {
  const {refetch} = useDescriptionData()
  useRefetchOnAliveUpdate(channel, refetch, {body_updated: true})
}
